import React from "react";
import PropTypes from "prop-types";

export default function TrashcanSVG({
  className,
  id,
  styles
}) {
  const {
    height,
    width,
    fill
  } = styles;

  return (
    <svg
      id={id}
      className={className}
      width={width || "32px"}
      height={height || "32px"}
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg">
      <title>Icon/Action/Delete</title>
      <g
        id="Icon/Action/Delete"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <path
          d="M19.6666667,0 L19.6666667,2.66666667 L31.6666667,2.66666667 L31.6666667,5.33333333 L6.33333333,5.33333333 L6.33333333,29.3333333 L26.3333333,29.3333333 L26.3333333,6.66666667 L29,8 L29,32 L3.66666667,32 L3.66666667,5.33333333 L1,5.33333333 L1,2.66666667 L13,2.66666667 L13,0 L19.6666667,0 Z M13.6666667,10 L13.6666667,24.6666667 L11,24.6666667 L11,10 L13.6666667,10 Z M21.6666667,10 L21.6666667,24.6666667 L19,24.6666667 L19,10 L21.6666667,10 Z"
          id="delete"
          fill={fill || "#677383"}>
        </path>
      </g>
    </svg>
  );
}

TrashcanSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};

TrashcanSVG.defaultProps = {
  id: "",
  className: "",
  styles: {
    fill: "#677383",
    height: "32px",
    width: "32px"
  }
};
